import { PLAN_NETWORKS, PlanNetwork, networkLabel } from '../plans/planNetwork';
import type { Router } from './routers';

/** A router can also be sold on every network, which a plan cannot. */
export type RouterNetwork = PlanNetwork | 'any';

/**
 * Which network supplies a router: the networks a plan can be on, plus
 * "every network" for something that is not a wholesaler's product at all.
 * Bringing your own router is the case that needs it, and marking it DGtek
 * (which is what an empty network means) took it away from a Community
 * Fibre sign up.
 */
export const ROUTER_NETWORKS: { value: RouterNetwork; label: string }[] = [
  ...PLAN_NETWORKS,
  { value: 'any', label: 'All networks' },
];

export const routerNetworkLabel = (network: RouterNetwork): string => (
  network === 'any' ? 'All networks' : networkLabel(network)
);

/** Empty on a record means DGtek: every router made before the field had one. */
export const networkOfRouter = (router: Router): RouterNetwork => {
  if (router.network === 'communityfibre') return 'communityfibre';
  if (router.network === 'any') return 'any';
  return 'dgtek';
};
